import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Box } from '@material-ui/core';
import useStyles from './useStyles';

const Loader = props => {
  const { fullFill } = props;
  const classes = useStyles();

  if (fullFill) {
    return (
      <Box className={classes.container}>
        <CircularProgress className={classes.root} />
      </Box>
    );
  }

  return <CircularProgress className={classes.root} />;
};

Loader.propTypes = {
  fullFill: PropTypes.bool,
};

Loader.defaultProps = {
  fullFill: false,
};

export default Loader;



// WEBPACK FOOTER //
// ./src/sharedComponents/Loader/Loader.js